module.exports = __webpack_public_path__ + "img/13800.719928c0.jpg";